<template>
	<div>
		<div class="dingdan">
			<el-breadcrumb separator-class="el-icon-arrow-right">
			  <el-breadcrumb-item :to="{ path: '/serviceHome/serviceOrder' }">我的订单</el-breadcrumb-item>
			  <el-breadcrumb-item>订单详情</el-breadcrumb-item>
			</el-breadcrumb>
			<div class="fh_button">
				<i class="el-icon-arrow-left"></i>
				<p>返回</p>
			</div>
		</div>
		<div class="container">
			<div class="leftsidebar">
				<div class="leftsidebarTitle">
					<h3>{{datails.demand.name}}</h3>
					<p>订单编号：{{datails.order_sn}}</p>
				</div>
				<div class="leftsidebarDox">
					<div class="leftsidebarDox1">
						<h3>需求方</h3>
						<div class="leftsidebarDox1_1">
							<img :src="datails.demandUser.avatar" alt="" srcset="" />
							<div>{{datails.demandUser.nickname}}</div>
						</div>
					</div>
					<div class="leftsidebarDox2">
						<h3>订单金额</h3>
						<div>
							￥{{datails.total_price}}
						</div>
					</div>
					<div class="leftsidebarDox1">
						<h3>服务方</h3>
						<div class="leftsidebarDox1_1">
							<img :src="datails.serveUser.avatar" alt="" srcset="" />
							<div>{{datails.serveUser.nickname}}</div>
						</div>
					</div>
				</div>
				<div class="leftsidebarTitle">
					<!-- 待支付 -->
					<el-descriptions title="订单信息">
					    <el-descriptions-item label="中标时间：">kooriookami</el-descriptions-item>
					</el-descriptions>
					<!-- 已完成 -->
					<el-descriptions title="订单信息">
					    <el-descriptions-item label="中标时间：">kooriookami</el-descriptions-item>
						<el-descriptions-item label="支付时间：">kooriookami</el-descriptions-item>
					    <el-descriptions-item label="承认图验收时间：">kooriookami</el-descriptions-item>
					    <el-descriptions-item label="承认图结算金额：">kooriookami</el-descriptions-item>
						<el-descriptions-item label="生产图验收时间：">kooriookami</el-descriptions-item>
						<el-descriptions-item label="生产图结算金额：">kooriookami</el-descriptions-item>
					</el-descriptions>
					<!-- 承认图阶段 -->
					<el-descriptions title="订单信息">
					    <el-descriptions-item label="中标时间：">kooriookami</el-descriptions-item>
						<el-descriptions-item label="支付时间：">kooriookami</el-descriptions-item>
					    <el-descriptions-item label="承认图结算金额：">kooriookami</el-descriptions-item>
					</el-descriptions>
					<!-- 承认图已退款 -->
					<el-descriptions title="订单信息">
					    <el-descriptions-item label="中标时间：">kooriookami</el-descriptions-item>
						<el-descriptions-item label="支付时间：">kooriookami</el-descriptions-item>
					    <el-descriptions-item label="退款时间：">kooriookami</el-descriptions-item>
						<el-descriptions-item label="退款阶段：">kooriookami</el-descriptions-item>
						<el-descriptions-item label="订单退款金额：">kooriookami</el-descriptions-item>
					</el-descriptions>
					<!-- 生产图已退款 -->
					<el-descriptions title="订单信息">
					    <el-descriptions-item label="中标时间：">kooriookami</el-descriptions-item>
						<el-descriptions-item label="支付时间：">kooriookami</el-descriptions-item>
						<el-descriptions-item label="承认图验收时间：">kooriookami</el-descriptions-item>
						<el-descriptions-item label="承认图结算金额：">kooriookami</el-descriptions-item>
					    <el-descriptions-item label="退款时间：">kooriookami</el-descriptions-item>
						<el-descriptions-item label="退款阶段：">kooriookami</el-descriptions-item>
						<el-descriptions-item label="订单退款金额：">kooriookami</el-descriptions-item>
					</el-descriptions>
					<!-- 生产图阶段 -->
					<el-descriptions title="订单信息">
					    <el-descriptions-item label="中标时间：">kooriookami</el-descriptions-item>
						<el-descriptions-item label="支付时间：">kooriookami</el-descriptions-item>
					    <el-descriptions-item label="承认图验收时间：">kooriookami</el-descriptions-item>
						<el-descriptions-item label="承认图结算金额：">kooriookami</el-descriptions-item>
						<el-descriptions-item label="生产图结算金额：">kooriookami</el-descriptions-item>
					</el-descriptions>
				</div>
			</div>
			<div class="rightsidebar">
				
				<div class="rightsidebar1" v-if="datails.status==-1">
					<h3>已取消</h3>
					<p>订单已取消，您可查看其他订单</p>
				</div>
				<div class="rightsidebar1" v-if="datails.status==-2">
					<h3>已退款</h3>
					<p>支付金额原路退回</p>
				</div>
				<div class="rightsidebar1" v-if="datails.status==0">
					<h3>待支付</h3>
					<p>剩余支付时间 <CountDown :endTime="datails.auto_cancel_time*1000"></CountDown></p>
				</div>
				<div class="rightsidebar1" v-if="datails.status==1">
					<h3>待上传承认图</h3>
					<p>剩余交付时间 <CountDown :endTime="datails.stageOne.upload_countdown*1000"></CountDown></p>
				</div>
				<div class="rightsidebar1" v-if="datails.status==2">
					<h3>承认图待验收</h3>
					<p v-if="!datails.stageOne.review">
						剩余验收时间 <CountDown :endTime="datails.stageOne.auto_confirm_time*1000"></CountDown>
					</p>
					<p v-if="datails.stageOne.review">
						评审中，请您耐心等待
					</p>
				</div>
				<div class="rightsidebar1" v-if="datails.status==3">
					<h3>待上传生产图</h3>
					<p>
						剩余验收时间 <CountDown :endTime="datails.stageTwo.upload_countdown*1000"></CountDown>
					</p>
				</div>
				<div class="rightsidebar1" v-if="datails.status==4">
					<h3>生产图待验收</h3>
					<p>
						剩余验收时间 <CountDown :endTime="datails.stageTwo.auto_confirm_time*1000"></CountDown>
					</p>
				</div>
				<div class="rightsidebar1" v-if="datails.status==5">
					<h3>已完成</h3>
					<p>
						感谢您使用本平台
					</p>
				</div>
				
				<div class="rightsidebar2">
					<div class="rightsidebarTitle">附件</div>
					<div class="rightsidebarbox">
						<div class="rightsidebarbox1">
							<div v-for='(i,index) in nametype' :key="index" :class="{'ait':index==typeindex}" @click="qiehuan(index)">{{i.name}}</div>
						</div>
					</div>
					<div class="rightsidebarImgbox">
						<rightsidebarImg :list="sidebarImg" :lexing="typeindex"></rightsidebarImg>
						<div class="rightsidebarAdd">
							<img src="@/assets/add.png" alt="" srcset="" />
							<span>点击添加图片</span>
						</div>
						<p>仅支持上传图片，单个图片最大支持5M，最多不超过5次，每次1张。如需上传PDF，请登录PC端操作。</p>
					</div>
					
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		OrderDetail,
		OrderPay,
		OrderStageConfirm,
		OrderRating,
		CollectOId,
		invoicePrice,
		InvoiceApply,
		personal
	} from "@/api/api.js"
	import rightsidebarImg from '@/common/rightsidebarImg.vue';
	import CountDown from '@/common/CountDown.vue'
	export default {
	  name: 'HelloWorld',
	  components:{
		rightsidebarImg,
		CountDown
	  },
	  data() {
	    return {
		    nametype:[
				{name:"承认图"},
				{name:"生产图"}
			],
			typeindex:0,
			typeindex:0,
			datails:{
				demand:{},
				demandUser:{},
				serveUser:{},
				stageOne:{ files: [] },
				order_sn:"",
				total_price:0,
				demand_score:0
			},
			rateValue:"",
			readonly:false,
			sidebarImg:[],
			invoice_price:"",
			centerDialogVisible:false,
			oId:"",
			user:"",
	    }
	  },
	  computed:{
	  		  o_id() {
	  		    return this.$route.query.o_id || ''
	  		  }
	  },
	  mounted() {
	     this.getdatails()
	  },
	  methods: {
		getdatails(){
			const oid = this.o_id
			if(!oid){
				return
			}
			OrderDetail(oid,{}).then(res=>{
				const detail = res && res.data ? res.data.data : {}
				this.datails = detail || {}
				const stageOne = (detail && detail.stageOne) ? detail.stageOne : {}
				this.sidebarImg = stageOne.files || []
				if(parseInt(this.datails.demand_score)>0){
					this.rateValue=parseInt(this.datails.demand_score)
					this.readonly=true
				}
			})
		},
		handleCurrentChange(){
			
		},
		qiehuan(index){
			this.typeindex=index
		}
	  },
	}
</script>

<style scoped>
	.dingdan{
		width:1200px;
		margin:0 auto;
		padding:36px 0px;
		box-sizing: border-box;
		display:flex;
		justify-content:space-between;
		align-items: center;
	}
	.fh_button{
		width: 58px;
		height: 24px;
		line-height:24px;
		background: #1E3A8A;
		border-radius: 4px ;
		font-weight: 500;
		font-size: 12px;
		color: #FFFFFF;
		display:flex;
		align-items:center;
		justify-content:center;
	}
	.fh_button i{
		margin-right:5px;
	}
	.container{
		width:1200px;
		margin: 0 auto;
		display:flex;
		justify-content:space-between;
	}
	.leftsidebar{
		width:790px;
	}
	.rightsidebar{
		width:384px;
	}
	.leftsidebarTitle{
		width:100%;
		padding:20px;
		box-sizing: border-box;
		background: #FFFFFF;
		border-radius:12px;
		margin-bottom:24px;
	}
	.leftsidebarTitle span{
		font-weight: 400;
		font-size: 16px;
		color: #666666;
	}
	.leftsidebarDox{
		width:100%;
		padding:20px;
		box-sizing: border-box;
		background: #FFFFFF;
		border-radius:12px;
		margin-bottom:24px;
		display:flex;
		justify-content:space-between;
	}
	.leftsidebarDox1 h3{
		font-weight: bold;
		font-size: 14px;
		color: #333333;
	}
	.leftsidebarDox1_1{
		width:200px;
		display:flex;
		align-items: center;
		margin-top:12px;
	}
	.leftsidebarDox1_1 img{
		width: 32px;
		height: 32px;
		margin-right:12px;
		border-radius:50%;
	}
	.leftsidebarDox1_1 div{
		font-weight: 500;
		font-size: 14px;
		color: #666666;
	}
	.leftsidebarDox2 h3{
		font-weight: bold;
		font-size: 14px;
		color: #333333;
	}
	.leftsidebarDox2 div{
		font-weight: bold;
		font-size: 24px;
		color: #FF5900;
		margin-top:15px;
	}
	.rightsidebar1{
		width:100%;
		height: 108px;
		background: #FFFFFF;
		box-shadow: 0px 4px 4px 0px rgba(0,0,0,0.05);
		border-radius: 12px;
		display:flex;
		justify-content:center;
		flex-wrap:wrap;
		flex-direction: column;
		text-align:center;
		margin-bottom:24px;
	}
	.rightsidebar1 h3{
		text-align:center;
		width:100%;
	}
	.rightsidebar1 p{
		color:#FF5900;
	}
	.rightsidebar2{
		width:100%;
		background: #FFFFFF;
		box-shadow: 0px 4px 4px 0px rgba(0,0,0,0.05);
		border-radius: 12px;
		padding:20px;
		box-sizing: border-box;
	}
	.rightsidebarbox{
		width:100%;
		display:flex;
		align-items: center;
		justify-content:center;
		margin-top:12px;
	}
	.rightsidebarbox1{
		width: 220px;
		height: 46px;
		background: #1E3A8A;
		border-radius: 26px 26px 26px 26px;
		border: 1px solid #FFFFFF;
		opacity: 0.6;
		padding:7px 12px;
		box-sizing: border-box;
		display:flex;
		justify-content:space-between;
		align-items: center;
	}
	.rightsidebarbox1 div{
		width:94px;
		height:32px;
		line-height:32px;
		font-weight: 500;
		font-size: 14px;
		color: #FFFFFF;
		display: flex;
		text-align: center;
		justify-content: center;
		cursor:pointer;
	}
	.ait{
		background: #FFFFFF;
		border-radius: 16px;
		border: 1px solid #1E3A8A;
		color: #1E3A8A !important;
	}
	.rightsidebarAdd{
		width:100%;
		height: 44px;
		background: #FFFFFF;
		display:flex;
		justify-content: center;
		align-items: center;
		border:1px dashed  #1E3A8A;
		border-radius:8px;
		margin-top:12px;
		cursor:pointer;
	}
	.rightsidebarAdd img{
		width:16px;
		height:16px;
		margin-right:5px;
	}
	.rightsidebarAdd span{
		font-weight: 400;
		font-size: 14px;
		color: #1E3A8A;
	}
	.rightsidebarImgbox p{
		font-weight: 400;
		font-size: 12px;
		color: #666666;
		margin-top:12px;
	}
</style>